var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-img",style:({height: _vm.height === 'auto' ? 'auto' : (_vm.height / 100).toFixed(2) + 'rem'})},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }